module.exports = __webpack_public_path__ + "img/popup_warning.5ad88691.jpg";